import { atom } from 'jotai';

import { cycleCountTaskDetailQueryAtom } from '../_graphql/queryCycleCountTask';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

export const $routeParams = atomFromRoutePath(
  '/inventory/counts/tasks/:taskId',
);

export const $linesLimit = atomFromQueryString.number('limit', 100);
export const $linesOffset = atomFromQueryString.number('offset', 0);

export const $taskId = atom((get) => {
  const params = get($routeParams);
  return params.__didMatch ? params.taskId : undefined;
});

export const $remoteTaskDetail = cycleCountTaskDetailQueryAtom((get) => {
  const taskId = get($taskId);
  const linesLimit = get($linesLimit);
  const linesOffset = get($linesOffset);

  if (!taskId) {
    return {
      variables: {
        id: '',
        linesLimit: 100,
        linesOffset: 0,
      },
      skip: true,
    };
  }

  return {
    variables: {
      id: taskId,
      linesLimit,
      linesOffset,
    },
    skip: false,
  };
});
